import { useContext } from 'react'
import { CollapsibleCardGroupContext } from './collapsibleCardGroupContext'

export const useCollapsibleCardGroup = () => useContext(CollapsibleCardGroupContext)
